<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form @submit.prevent="submit()">
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">Editar encuesta publicada</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        :error-messages="nameErrors"
                        v-model="$v.pollForm.title.$model"
                        label="Titulo"
                        required
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn :disabled="working.wUpdate" flat @click="cancel">Cancelar</v-btn>
            <v-btn :disabled="working.wUpdate" color="primary darken-1" type="submit" flat>Guardar</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."/>
    <success v-model="toast.success" text="Creación Exitosa"/>
    <error v-model="toast.failed" :text="toast.eMessage"/>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import loading from "../../Dialogs/Loading.vue";
import success from "../../Dialogs/Success.vue";
import error from "../../Dialogs/Error.vue";

export default {
  props: ["value", "poll"],
  components: {
    loading,
    success,
    error,
  },
  validations: {
    pollForm: {
      title: { required }
    },
  },
  watch: {
    value() {
      if (this.value) {
        if (this.poll !== null) {
          this.pollForm.id = this.poll.id;
          this.pollForm.title = this.poll.title;
        }
      }
    },
  },
  mounted() {},
  data: () => ({
    pollForm: {
      title: ""
    },
    working: {
      wUpdate: false,
    },
    toast: {
      success: false,
      failed: false,
      eMessage: "",
    }
  }),
  methods: {
    submit(event = null) {
      this.$v.pollForm.$touch();
      if (!this.$v.pollForm.$invalid) {
        this.working.wUpdate = true;
        this.$store
        .dispatch("polls/update", this.pollForm)
        .then((response) => {
            this.working.wUpdate = false;
            this.$v.pollForm.$reset();
            this.$emit("created", true, response.data);
            this.close();
        })
        .catch(() => {
            this.working.wUpdate = false;
            this.$emit("created", false, null);
        });
        
      }
    },
    cancel() {
      this.$emit("cancelled");
      this.close();
    },
    close() {
      this.$v.pollForm.$reset();
      this.pollForm = {
        title: "",
      };
    }
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.pollForm.title.$dirty) return errors;
      !this.$v.pollForm.title.required && errors.push("Título obligatorio");
      return errors;
    }
  },
};
</script>

<style>
</style>
